/**
 * Exclude "-" in input 
 * 
 * @param {String} email 
 * @returns {Boolean}
 */
export const validatInputEmail = email => {
    const regEx = /^[a-zA-Z0-9]+(?:[@.][a-zA-Z0-9\s]+)*$/;
    return regEx.test(email);
};

export const validatCloudCFOEmail = email => {
    const regEx = /^[a-zA-Z0-9]+(?:[@.-][a-zA-Z0-9\s]+)*$/;
    return regEx.test(email);
};

export const getSuggested = value => {
    return value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
};

export const getPrefix = (email, character='@') => {
    return email.split(character)[0];
};